export default __webpack_public_path__ + "static/apple_man-520b01c55872bb2972873f459c7d709b.jpg";